import React from 'react';
import { Card } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { managerPerformanceInsightsHighchartsOptions } from 'components/insights/manager-performance-insights/manager-performance-insights-highcharts-options';
import type { IManagerPerformanceInsightsProps } from 'components/insights/manager-performance-insights/types';

export const ManagerPerformanceInsights: React.FC<IManagerPerformanceInsightsProps> = (props) => {
  const { title, seriesData } = props;

  const options = managerPerformanceInsightsHighchartsOptions(seriesData);

  return (
    <Card title={title}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
};
